import { Component, OnInit } from '@angular/core';
import { ProjectService } from '../services/project.service';
import { AuthService } from '../services/auth.service';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { filter, pairwise } from 'rxjs/operators';

@Component({
  selector: 'app-create-project',
  imports: [FormsModule, CommonModule, RouterModule, MatIconModule],
  templateUrl: './create-project.component.html',
  styleUrl: './create-project.component.css'
})
export class CreateProjectComponent implements OnInit {
  project = {
    projectNumber: 0,
    projectName: '',
    pm: '',
    outsourcePm: '',
    dateCreated: '',
    dateUpdated: '',
    closedDate: null as string | null,
  };

  loading = false;
  error: string | null = null;
  success = false;
  cameFromProjects = false;
  company: string | null = null;

  constructor(private projectService: ProjectService, private router: Router, private authService: AuthService) {}

  ngOnInit() {
    this.company = this.authService.getCompany();
    const nav = this.router.getCurrentNavigation();
    const prevUrl = nav?.previousNavigation?.extractedUrl?.toString();
    if (prevUrl === '/projects') {
      this.cameFromProjects = true;
    }
  }

  createProject() {
    this.loading = true;
    this.error = null;

    const now = new Date().toISOString();
    this.project.dateCreated = now;
    this.project.dateUpdated = now;

    this.projectService.createProject(this.project).subscribe({
      next: () => {
        this.success = true;
        this.router.navigate(['/projects']);
      },
      error: (err) => {
        this.error = 'Failed to create project.';
        console.error(err);
        this.loading = false;
      }
    });
  }
}
